import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`Functions`}</p>
    <dl>
      <dt><a href="#getBackgroundImages">getBackgroundImages(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve background images from a master format node`}</p>
      </dd>
      <dt><a href="#getVerticalAlignment">getVerticalAlignment(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve vertical alignment from a master format node`}</p>
      </dd>
      <dt><a href="#verticalAlignmentToFlex">verticalAlignmentToFlex(alignment)</a> ⇒ <inlineCode>\*</inlineCode></dt>
      <dd>
        <p>{`Convert vertical alignment values to flex values`}</p>
      </dd>
      <dt><a href="#flexToVerticalAlignment">flexToVerticalAlignment(flex)</a> ⇒ <inlineCode>\*</inlineCode></dt>
      <dd>
        <p>{`Convert flex to vertical alignment values`}</p>
      </dd>
      <dt><a href="#getAdvanced">getAdvanced(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve advanced props from content type node`}</p>
      </dd>
      <dt><a href="#getPadding">getPadding(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve the padding from a content type node`}</p>
      </dd>
      <dt><a href="#getMargin">getMargin(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve the margin from a content type node`}</p>
      </dd>
      <dt><a href="#getBorder">getBorder(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve the border from a content type node`}</p>
      </dd>
      <dt><a href="#getTextAlign">getTextAlign(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve the text align from a content type node`}</p>
      </dd>
      <dt><a href="#getCssClasses">getCssClasses(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve the CSS classes from a content type node`}</p>
      </dd>
      <dt><a href="#getIsHidden">getIsHidden(node)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve if CSS display property is set to none from a content type node`}</p>
      </dd>
      <dt><a href="#cssToJSXStyle">cssToJSXStyle(style)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Converts a CSS string style into a JSX object inline style`}</p>
      </dd>
      <dt><a href="#getMediaQueries">getMediaQueries(node, mediaQueries)</a> ⇒ <inlineCode>Object</inlineCode></dt>
      <dd>
        <p>{`Retrieve media queries from a master format node`}</p>
      </dd>
    </dl>
    <p>{`Retrieve background images from a master format node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve vertical alignment from a master format node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Convert vertical alignment values to flex values`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`alignment`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Convert flex to vertical alignment values`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`flex`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve advanced props from content type node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve the padding from a content type node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve the margin from a content type node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve the border from a content type node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve the text align from a content type node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve the CSS classes from a content type node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve if CSS display property is set to none from a content type node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Converts a CSS string style into a JSX object inline style`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`style`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`String`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p>{`Retrieve media queries from a master format node`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`node`}</td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`mediaQueries`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pagebuilder/lib/utils.js"
      }}>{`pwa-studio/packages/pagebuilder/lib/utils.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      